import { render, staticRenderFns } from "./ClientModal.vue?vue&type=template&id=4ff0027f"
import script from "./ClientModal.vue?vue&type=script&lang=js"
export * from "./ClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports